import FirstPlaceIcon from 'assets/images/icon-first-place.svg'
import SecondPlaceIcon from 'assets/images/icon-second-place.svg'
import ThirdPlaceIcon from 'assets/images/icon-third-place.svg'
import RandomPrizeIcon from 'assets/images/random-prize.png'

import { FC } from 'react';
// Components
import Dialog from 'components/Dialog';
import { Button } from 'components/Buttons';
import GradientIcon from 'components/GradientIcon';
// Icons
import { IoClose } from "react-icons/io5";
// i18next
import { useTranslation } from 'react-i18next';

type Props = {
  onClose: () => void;
  prizes: string[];
  spotPrizes?: string[];
}

const PrizesDialog:FC<Props> = ({ onClose, prizes, spotPrizes }) => {
  const { t } = useTranslation();

  const icons = [FirstPlaceIcon, SecondPlaceIcon, ThirdPlaceIcon];

  return (
    <Dialog background='none' classes="backdrop-blur-sm">
      <div className="relative max-w-full mx-4 p-4 border border-white rounded-xl bg-[#212938] overflow-y-auto" style={{ background: 'url(/images/prizes-bg.png)' }}>
        <h2 className="text-center text-4xl font-bold text-white mb-8">
          {t('labels.youCouldWin')}
        </h2>
        <div className="min-h-[300px] overflow-y-auto">
          {prizes.map((prize, index) => (
            <div key={`prize-${index}-${prize}`} className="mb-4 flex items-center gap-2">
              <div className="w-12 flex justify-center flex-shrink-0">
                {index < 3 ? (
                  <img src={icons[index]} alt={`Prize-${index + 1}`} className={index === 0 ? 'h-10' : 'h-8'} /> 
                ) : (
                  <GradientIcon />
                )}
              </div>
              <p className="text-xl font-bold text-white whitespace-normal break-words min-w-0 overflow-hidden">
                {prize}
              </p>
            </div>
          ))}
          {spotPrizes?.map((prize, index) => (
            <div key={`random-prize-${index}-${prize}`} className="mb-4 flex items-center gap-2">
              <div className="w-12 flex justify-center flex-shrink-0">
                <img src={RandomPrizeIcon} alt={`Random-Prize-${index + 1}`} className="h-8" /> 
              </div>
              <p className="text-xl font-bold text-white whitespace-normal break-words min-w-0 overflow-hidden">
                {prize}
              </p>
            </div>
          ))}
        </div>
        <Button
          onClick={onClose}
          className="primary-button flex items-center gap-2 mx-auto"
          size="small"
        >
          <span>{t('buttons.close')}</span>
          <IoClose className="text-2xl" />
        </Button>
      </div>
    </Dialog>
  )
}

export default PrizesDialog;